import * as React from "react";
const SvgMaximize20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8 1H1v7h2V3h5V1Zm11 0h-7v2h5v5h2V1Zm0 11v7h-7v-2h5v-5h2ZM3 17v-5H1v7h7v-2H3Z",
      clipRule: "evenodd"
    })
  );
export default SvgMaximize20Px;
